import React, { useEffect, useState } from 'react';
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import './certification.css'
import CertificateCard from './CertificateCard';
// import ChartList from './ChartList';
const Certification = () => {

    const [responseInfo, setResourceInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.certification,
            })
            .then((response) => {
                const resourcesDoc = response.data.allCertifications.edges[0].node;
                setResourceInfo(resourcesDoc);
                window.scrollTo(0, 0);


            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <section style={{ backgroundImage: 'url(' + responseInfo?.section_bg?.url + ')' }} className=" certificate-section pattern">
            < div className="container " >
                <h5 className="section-title  pb-4" > {responseInfo?.title}</h5>
                <p>{responseInfo?.desc}</p>
                < div className="row gx-2  gy-2" >
                    {
                        responseInfo?.recognizers?.map((info, index) =>
                            < CertificateCard
                                key={index + 1}
                                index={index + 1}
                                info={info}
                            >
                            </CertificateCard>
                        )
                    }

                </div>

                <p className="footer-email mt-3"> {responseInfo?.footer_text} <a target="_blank" href={"mailto:" + responseInfo?.email}>{responseInfo?.email}</a></p>
            </div>

        </section >
    );
};

export default Certification;